(function() {
  'use strict';

  var dom = {};
  var drag = { isDragging: false, startX: 0, scrollLeft: 0, moved: false, slider: null };
  var debounceTimer = null;
  var renderRequestId = 0;
  var loadedCartSignature = null;
  var inFlightCartSignature = null;
  var cartRequestPromise = null;
  var cartRequestId = 0;
  var cartAbortController = null;
  var collectionProductsPromise = null;

  var CONFIG = {
    productsLimit: 6,
    collectionHandle: 'recommended-products-to-cart',
    addLabel: 'Add'
  };

  function init() {
    dom.container = document.getElementById('UpsellRecommendations');
    dom.slider = document.getElementById('UpsellSlider');
    if (!dom.container || !dom.slider) return;
    if (dom.container.getAttribute('data-upsell-initialized') === 'true') return;
    dom.container.setAttribute('data-upsell-initialized', 'true');

    mergeConfig();
    bindEvents();
    buildNavigation();
    refreshCartRecommendations();

    if (dom.slider.querySelectorAll('.upsell-product').length === 0) {
      dom.container.classList.add('upsell-recommendations--empty');
    }
  }

  function mergeConfig() {
    if (window.upsellConfig) {
      CONFIG.productsLimit = window.upsellConfig.productsLimit || CONFIG.productsLimit;
      CONFIG.collectionHandle = window.upsellConfig.collectionHandle || CONFIG.collectionHandle;
      CONFIG.addLabel = window.upsellConfig.addLabel || CONFIG.addLabel;
    }
  }

  function bindEvents() {
    dom.container.addEventListener('click', onContainerClick);
    dom.container.addEventListener('change', onVariantChange);

    dom.slider.addEventListener('mousedown', onDragStart);
    dom.slider.addEventListener('touchstart', onTouchStart, { passive: true });
    dom.slider.addEventListener('touchmove', onTouchMove, { passive: true });
    dom.slider.addEventListener('touchend', onTouchEnd);
    dom.slider.addEventListener('scroll', onScroll);

    document.addEventListener('cart:open', onCartOpen);
    document.addEventListener('drawerOpen.CartDrawer', onCartOpen);
    document.addEventListener('cart:updated', onCartUpdated);
    document.addEventListener('cart:rendered', scheduleRefresh);
    document.addEventListener('ajaxProduct:added', scheduleRefresh);
  }

  function onContainerClick(e) {
    if (drag.moved) {
      e.preventDefault();
      return;
    }

    var addBtn = e.target.closest('.upsell-product__add-btn');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      addToCart(addBtn);
      return;
    }

    var dot = e.target.closest('.upsell-recommendations__dot');
    if (dot) {
      e.preventDefault();
      scrollToProduct(parseInt(dot.dataset.index, 10));
    }
  }

  function onVariantChange(e) {
    if (!e.target.classList.contains('upsell-product__variant-select')) return;
    var select = e.target;
    var productEl = select.closest('.upsell-product');
    var addBtn = productEl.querySelector('.upsell-product__add-btn');
    var priceEl = productEl.querySelector('.upsell-product__price');
    var imageEl = productEl.querySelector('.upsell-product__image');

    var selectedOption = select.options[select.selectedIndex];
    var variantId = selectedOption.value;

    if (addBtn) {
      addBtn.setAttribute('data-variant-id', variantId);
    }

    if (priceEl && selectedOption) {
      var price = selectedOption.dataset.price;
      var comparePrice = selectedOption.dataset.comparePrice;

      if (comparePrice && parseInt(comparePrice, 10) > parseInt(price, 10)) {
        priceEl.innerHTML = '<span class="upsell-product__price--sale">' + formatMoney(price) + '</span> '
          + '<span class="upsell-product__price--compare">' + formatMoney(comparePrice) + '</span>';
      } else {
        priceEl.textContent = formatMoney(price);
      }
    }

    if (imageEl && selectedOption && selectedOption.dataset.image) {
      imageEl.src = selectedOption.dataset.image;
    }

    if (addBtn) {
      addBtn.disabled = selectedOption.disabled;
    }
  }

  function formatMoney(cents) {
    var theme = window.theme;
    if (theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    var amount = (parseInt(cents, 10) / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var productEl = btn.closest('.upsell-product');
    setButtonLoading(btn, true);

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(err) {
          throw err;
        });
      }
      return response.json();
    })
    .then(function(data) {
      setButtonLoading(btn, false);
      showToast('Added to cart', 'success');
      removeProduct(productEl);
      notifyCartUpdate(data, btn);
    })
    .catch(function(error) {
      setButtonLoading(btn, false);
      showToast(error.description || error.message || 'Failed to add to cart', 'error');
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: { errorMessage: error.description || error.message || 'Failed to add to cart' }
      }));
    });
  }

  function removeProduct(productEl) {
    if (!productEl || !productEl.parentNode) return;

    productEl.classList.add('is-removing');

    setTimeout(function() {
      if (productEl.parentNode) {
        productEl.parentNode.removeChild(productEl);
      }
      updateNavigation();
    }, 300);
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    var textEl = btn.querySelector('.upsell-product__add-btn-text');
    var loadEl = btn.querySelector('.upsell-product__add-btn-loading');

    if (loading) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      if (textEl) textEl.style.display = 'none';
      if (loadEl) loadEl.style.display = 'inline-flex';
    } else {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      if (textEl) textEl.style.display = '';
      if (loadEl) loadEl.style.display = 'none';
    }
  }

  function notifyCartUpdate(data, button) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      bubbles: true,
      // Preserve the actual entry and submitted quantity for independent analytics.
      detail: { product: data, addToCartBtn: button, quantity: 1, source: 'upsell_recommendations' }
    }));
    if (document.body.classList.contains('template-cart')) {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }

  function buildNavigation() {
    removeNavigation();

    var products = getVisibleProducts();
    if (products.length <= 1) return;

    var nav = document.createElement('div');
    nav.className = 'upsell-recommendations__nav';

    for (var i = 0; i < products.length; i++) {
      var dot = document.createElement('button');
      dot.className = 'upsell-recommendations__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to product ' + (i + 1));
      dot.setAttribute('data-index', i);
      nav.appendChild(dot);
    }

    dom.slider.parentNode.appendChild(nav);
  }

  function removeNavigation() {
    var nav = dom.container.querySelector('.upsell-recommendations__nav');
    if (nav) nav.parentNode.removeChild(nav);
  }

  function updateNavigation() {
    removeNavigation();
    buildNavigation();
  }

  function getVisibleProducts() {
    return Array.prototype.filter.call(dom.slider.querySelectorAll('.upsell-product'), function(product) {
      return product.style.display !== 'none';
    });
  }

  function onScroll() {
    if (!dom.slider) return;
    var scrollLeft = dom.slider.scrollLeft;
    var products = getVisibleProducts();
    var activeIndex = 0;

    if (products.length === 0) return;

    products.forEach(function(product, i) {
      if (Math.abs(product.offsetLeft - scrollLeft) < Math.abs(products[activeIndex].offsetLeft - scrollLeft)) {
        activeIndex = i;
      }
    });

    var dots = dom.container.querySelectorAll('.upsell-recommendations__dot');
    dots.forEach(function(dot, i) {
      dot.classList.toggle('is-active', i === activeIndex);
    });
  }

  // 新旧购物车共用原有平滑滚动；允许新版传入自己的卡片，不绑定旧容器。
  function scrollToProduct(index, cards, behavior) {
    var products = cards || getVisibleProducts();
    if (products[index]) {
      products[index].scrollIntoView({ behavior: behavior || 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  function onCartOpen() {
    refreshCartRecommendations();
  }

  function onCartUpdated(e) {
    var cart = e.detail && e.detail.cart;
    if (cart && cart.items) {
      refreshCartRecommendations(cart);
    } else {
      scheduleRefresh();
    }
  }

  function scheduleRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      refreshCartRecommendations();
    }, 100);
  }

  function refreshCartRecommendations(cart) {
    if (cart && cart.items) {
      cartRequestId++;
      cartRequestPromise = null;
      if (cartAbortController) cartAbortController.abort();
      cartAbortController = null;
      renderCollectionForCart(cart);
      return;
    }

    if (cartRequestPromise) return;

    var requestId = ++cartRequestId;
    var requestController = typeof AbortController === 'function'
      ? new AbortController()
      : null;
    cartAbortController = requestController;
    var requestOptions = { credentials: 'same-origin' };
    if (requestController) requestOptions.signal = requestController.signal;

    cartRequestPromise = fetch(shopRoot() + 'cart.js', requestOptions)
      .then(function(res) {
        if (!res.ok) throw new Error('Unable to load cart');
        return res.json();
      })
      .then(function(fetchedCart) {
        if (requestId === cartRequestId) {
          renderCollectionForCart(fetchedCart);
        }
      })
      .catch(function() {
        if (requestId !== cartRequestId) return;
        loadedCartSignature = null;
        inFlightCartSignature = null;
        hideRecommendations();
        setStatus('error', [], 0);
      })
      .then(function() {
        if (requestId === cartRequestId) {
          cartRequestPromise = null;
          cartAbortController = null;
        }
      });
  }

  function renderCollectionForCart(cart) {
    var items = cart.items || [];
    var cartProductIds = [];

    items.forEach(function(item) {
      var productId = parseInt(item.product_id, 10);
      if (productId && cartProductIds.indexOf(productId) === -1) {
        cartProductIds.push(productId);
      }
    });

    var signature = cartProductIds.join(',');
    if (signature === loadedCartSignature || signature === inFlightCartSignature) return;

    // Once the cart changes, the previous rendered result is no longer a valid
    // cache entry. If the cart changes back while a request is in flight, fetch
    // it again instead of allowing the stale request to overwrite the UI.
    loadedCartSignature = null;
    var requestId = ++renderRequestId;
    inFlightCartSignature = signature;

    if (cartProductIds.length === 0) {
      loadedCartSignature = signature;
      inFlightCartSignature = null;
      hideRecommendations();
      setStatus('empty', [], 0);
      return;
    }

    hideRecommendations();
    setStatus('loading', cartProductIds, 0);

    loadCollectionProducts().then(function(products) {
      if (requestId !== renderRequestId) return;

      inFlightCartSignature = null;
      var visibleProducts = selectCollectionProducts(products, cartProductIds);
      var sourceResult = [{
        ok: true,
        sourceProductId: CONFIG.collectionHandle,
        products: products
      }];

      if (visibleProducts.length > 0) {
        renderProducts(visibleProducts);
        setStatus('loaded', cartProductIds, visibleProducts.length, sourceResult);
      } else {
        hideRecommendations();
        setStatus('empty', cartProductIds, 0, sourceResult);
      }

      loadedCartSignature = signature;
    }).catch(function() {
      if (requestId !== renderRequestId) return;
      inFlightCartSignature = null;
      loadedCartSignature = null;
      hideRecommendations();
      setStatus('error', cartProductIds, 0);
    });
  }

  function loadCollectionProducts() {
    if (collectionProductsPromise) return collectionProductsPromise;

    var fetchLimit = Math.max(CONFIG.productsLimit * 3, 18);
    var url = shopRoot() + 'collections/' + CONFIG.collectionHandle
      + '/products.json?limit=' + fetchLimit;

    collectionProductsPromise = fetch(url, { credentials: 'same-origin' })
      .then(function(res) {
        if (!res.ok) throw new Error('Unable to load cart recommendation collection');
        return res.json();
      })
      .then(function(data) {
        return (data.products || []).map(normalizeCollectionProduct);
      })
      .catch(function(error) {
        collectionProductsPromise = null;
        throw error;
      });

    return collectionProductsPromise;
  }

  // 新旧购物车共用同一集合接口、返回顺序、缓存及已购商品过滤。
  function selectCollectionProducts(products, cartProductIds) {
    return products.filter(function(product) {
      return product.available && cartProductIds.indexOf(parseInt(product.id, 10)) === -1;
    }).slice(0, CONFIG.productsLimit);
  }
  function productsForCart(cartProductIds) {
    return loadCollectionProducts().then(function(products) { return selectCollectionProducts(products, cartProductIds); });
  }

  function normalizeCollectionProduct(product) {
    var variants = (product.variants || []).map(function(variant) {
      return Object.assign({}, variant, {
        price: collectionMoneyToCents(variant.price),
        compare_at_price: collectionMoneyToCents(variant.compare_at_price)
      });
    });

    return Object.assign({}, product, {
      available: variants.some(function(variant) { return variant.available; }),
      featured_image: product.featured_image || (product.images && product.images[0]) || '',
      url: shopRoot() + 'products/' + product.handle,
      variants: variants
    });
  }

  function collectionMoneyToCents(value) {
    if (value === null || value === undefined || value === '') return null;
    var amount = parseFloat(value);
    return isNaN(amount) ? null : Math.round(amount * 100);
  }

  function renderProducts(products) {
    dom.slider.innerHTML = '';

    products.forEach(function(product) {
      var card = buildProductCard(product);
      if (card) dom.slider.appendChild(card);
    });

    var renderedCount = dom.slider.querySelectorAll('.upsell-product').length;
    if (renderedCount === 0) {
      hideRecommendations();
      return;
    }

    dom.container.classList.remove('upsell-recommendations--empty');
    show();
    updateNavigation();
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setStatus(status, sourceProductIds, resultCount, results) {
    if (!dom.container) return;
    dom.container.setAttribute('data-recommendation-status', status);
    dom.container.setAttribute('data-source-product-ids', sourceProductIds.join(','));
    dom.container.setAttribute('data-result-count', String(resultCount));
    dom.container.classList.toggle('is-loading', status === 'loading');
    dom.container.setAttribute('data-source-result-counts', JSON.stringify((results || []).map(function(result) {
      return {
        productId: result.sourceProductId,
        ok: result.ok,
        count: result.products.length
      };
    })));
  }

  function buildProductCard(product) {
    var fav = product.variants && product.variants.filter(function(variant) {
      return variant.available;
    })[0];
    if (!fav) return null;

    var card = document.createElement('div');
    card.className = 'upsell-product';
    card.setAttribute('data-product-id', product.id);
    card.setAttribute('data-variant-id', fav.id);

    var productUrl = product.url || shopRoot() + 'products/' + product.handle;
    var imageWrapper = document.createElement('div');
    imageWrapper.className = 'upsell-product__image-wrapper';

    var imageLink = document.createElement('a');
    imageLink.className = 'upsell-product__image-link';
    imageLink.href = productUrl;
    imageLink.setAttribute('aria-label', product.title || product.handle);
    imageLink.setAttribute('draggable', 'false');

    var image = document.createElement('img');
    image.className = 'upsell-product__image';
    var imageUrl = normalizeImageUrl(fav.featured_image || product.featured_image);
    if (imageUrl) image.src = imageUrl;
    image.alt = product.title || '';
    image.width = 70;
    image.height = 70;
    image.loading = 'lazy';
    image.decoding = 'async';
    imageLink.appendChild(image);
    imageWrapper.appendChild(imageLink);

    var content = document.createElement('div');
    content.className = 'upsell-product__content';

    var info = document.createElement('div');
    info.className = 'upsell-product__info';

    var title = document.createElement('a');
    title.className = 'upsell-product__title';
    title.href = productUrl;
    title.setAttribute('draggable', 'false');
    title.textContent = product.title || '';

    var price = document.createElement('div');
    price.className = 'upsell-product__price';
    if (fav.compare_at_price && fav.compare_at_price > fav.price) {
      var salePrice = document.createElement('span');
      salePrice.className = 'upsell-product__price--sale';
      salePrice.textContent = formatMoney(fav.price);

      var comparePrice = document.createElement('span');
      comparePrice.className = 'upsell-product__price--compare';
      comparePrice.textContent = formatMoney(fav.compare_at_price);

      price.appendChild(salePrice);
      price.appendChild(document.createTextNode(' '));
      price.appendChild(comparePrice);
    } else {
      price.textContent = formatMoney(fav.price);
    }

    info.appendChild(title);
    info.appendChild(price);

    var actions = document.createElement('div');
    actions.className = 'upsell-product__actions';

    if (product.variants && product.variants.length > 1) {
      var selectWrapper = document.createElement('div');
      selectWrapper.className = 'upsell-product__variant-select-wrapper';

      var select = document.createElement('select');
      select.className = 'upsell-product__variant-select';
      select.setAttribute('aria-label', 'Select variant');

      product.variants.forEach(function(variant) {
        if (!variant.available) return;

        var option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title;
        option.dataset.price = variant.price;
        option.dataset.comparePrice = variant.compare_at_price || '';
        option.dataset.image = normalizeImageUrl(variant.featured_image);
        option.selected = variant.id === fav.id;
        select.appendChild(option);
      });

      selectWrapper.appendChild(select);
      actions.appendChild(selectWrapper);
    }

    var addButton = document.createElement('button');
    addButton.type = 'button';
    addButton.className = 'upsell-product__add-btn';
    addButton.setAttribute('data-variant-id', fav.id);

    var buttonText = document.createElement('span');
    buttonText.className = 'upsell-product__add-btn-text';
    buttonText.textContent = CONFIG.addLabel || 'Add';

    var buttonLoading = document.createElement('span');
    buttonLoading.className = 'upsell-product__add-btn-loading';
    buttonLoading.style.display = 'none';
    buttonLoading.innerHTML = '<svg class="upsell-spinner" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">'
      + '<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" stroke-dasharray="31.4 31.4" stroke-linecap="round">'
      + '<animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"></animateTransform>'
      + '</circle></svg>';

    addButton.appendChild(buttonText);
    addButton.appendChild(buttonLoading);
    actions.appendChild(addButton);

    content.appendChild(info);
    content.appendChild(actions);
    card.appendChild(imageWrapper);
    card.appendChild(content);

    return card;
  }

  function normalizeImageUrl(image) {
    var url = image;
    if (url && typeof url === 'object') {
      url = url.src || url.url || '';
    }
    if (!url) return '';
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  function showToast(message, type) {
    var existing = document.querySelector('.upsell-toast');
    if (existing) existing.parentNode.removeChild(existing);

    var toast = document.createElement('div');
    toast.className = 'upsell-toast upsell-toast--' + (type || 'info');

    var icon = '';
    if (type === 'success') {
      icon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:8px">'
        + '<polyline points="20 6 9 17 4 12"/></svg>';
    }
    toast.innerHTML = icon + message;
    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 300);
    }, type === 'error' ? 3000 : 2000);
  }

  function hideRecommendations() {
    if (!dom.slider) return;
    dom.slider.innerHTML = '';
    dom.container.classList.add('upsell-recommendations--empty');
    dom.container.classList.add('is-hidden');
    updateNavigation();
  }

  function show() {
    if (dom.container) {
      dom.container.classList.remove('is-hidden');
    }
  }

  /* ---------- drag / swipe ---------- */

  function onDragStart(e) {
    if (e.target.closest('select, button')) return;
    e.preventDefault();
    var slider = e.currentTarget;
    drag.isDragging = true;
    drag.moved = false;
    drag.slider = slider;
    drag.startX = e.pageX;
    drag.scrollLeft = slider.scrollLeft;
    slider.style.cursor = 'grabbing';
    slider.style.userSelect = 'none';
    slider.style.scrollBehavior = 'auto';
    slider.style.scrollSnapType = 'none';
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
  }

  function onDragMove(e) {
    if (!drag.isDragging || !drag.slider) return;
    e.preventDefault();
    var x = e.pageX - drag.startX;
    if (Math.abs(x) > 5) drag.moved = true;
    drag.slider.scrollLeft = drag.scrollLeft - x;
  }

  function onDragEnd() {
    if (!drag.isDragging) return;
    drag.isDragging = false;
    var slider = drag.slider;
    if (slider) {
      slider.style.cursor = 'grab';
      slider.style.userSelect = '';
      slider.style.scrollBehavior = '';
      slider.style.scrollSnapType = '';
    }
    drag.slider = null;
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    setTimeout(function() { drag.moved = false; }, 10);
  }

  function onTouchStart(e) {
    drag.startX = e.touches[0].pageX - dom.slider.offsetLeft;
    drag.moved = false;
  }

  function onTouchMove(e) {
    var x = e.touches[0].pageX - dom.slider.offsetLeft;
    if (Math.abs(x - drag.startX) > 10) drag.moved = true;
  }

  function onTouchEnd() {
    setTimeout(function() { drag.moved = false; }, 100);
  }

  /* ---------- init ---------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.UpsellRecommendations = { init: init, scrollToProduct: scrollToProduct, productsForCart: productsForCart };
})();
